import AOS from 'aos';

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
	document.addEventListener('DOMContentLoaded', function () {
		const classToAos = {
			'animate-fade-up': 'fade-up',
			'animate-fade-down': 'fade-down',
			'animate-fade-left': 'fade-left',
			'animate-fade-right': 'fade-right',
			'animate-zoom-in': 'zoom-in',
			'animate-zoom-out': 'zoom-out',
			'animate-flip-up': 'flip-up',
			'animate-flip-down': 'flip-down',
			'animate-flip-left': 'flip-left',
			'animate-flip-right': 'flip-right'
		};

		Object.entries(classToAos).forEach(([className, aosType]) => {
			document.querySelectorAll('.' + className).forEach((el) => {
				el.setAttribute('data-aos', aosType);
			});
		});

		AOS.init({
			delay: 50,
			once: true,
			offset: 100
		});
	});
}
